import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      currentAccountId: 'getCurrentAccountId',
      isOpportunityEditAllowed: 'accounts/isOpportunityEditAllowed',
    }),
    canWriteOpportunities() {
      return this.isOpportunityEditAllowed(this.currentAccountId);
    },
  },
};
